import { Divider, FormControlLabel, ToggleButtonGroup, Tooltip, } from '@mui/material';
import Button from '../../Button';
import Checkbox from '../../Checkbox';
import Chip from '../../Chip';
import DatePicker from '../../DatePicker';
import DateTimePicker from '../../DateTimePicker';
import Select from '../../Select';
import SelectFormInput from '../../SelectFormInput';
import Switch from '../../Switch';
import TextField from '../../TextField/TextField';
import TextFormInput from '../../TextFormInput';
import TimePicker from '../../TimePicker';
import TimePickerFormInput from '../../TimePickerFormInput';
import ToggleButton from '../../ToggleButton';
import TopNavItem from '../../TopNavItem';
/**
 * A constant defining the supported elements. Note that we do not support the CheckboxFormInput as it does not make
 * sense in this `ActionGroup` component.
 */
export var Element = {
    BUTTON: {
        displayName: 'Button',
        type: Button,
    },
    CHECKBOX: {
        displayName: 'Checkbox',
        type: Checkbox,
    },
    CHIP: {
        displayName: 'Chip',
        type: Chip,
    },
    DATE_PICKER: {
        displayName: 'Date picker',
        isFormField: true,
        isShrinkable: true,
        minWidth: 130,
        type: DatePicker,
    },
    DATE_TIME_PICKER: {
        displayName: 'Date-time picker',
        isFormField: true,
        isShrinkable: true,
        minWidth: 175,
        type: DateTimePicker,
    },
    DROPDOWN_BUTTON: {
        // Special case - since we do not have a specific component for the dropdown button, we assume it is a compound
        // `React.Fragment` consisting of `Button` and `Menu` components.
        displayName: 'Dropdown button',
    },
    FORM_CONTROL: {
        displayName: 'Form control label',
        type: FormControlLabel,
    },
    SELECT: {
        displayName: 'Select',
        isShrinkable: false,
        type: Select,
    },
    SELECT_FORM_FIELD: {
        displayName: 'Select form input',
        isFormField: true,
        isShrinkable: false,
        type: SelectFormInput,
    },
    SEPARATOR: {
        displayName: 'Divider',
        type: Divider,
    },
    SWITCH: {
        displayName: 'Switch',
        type: Switch,
    },
    TEXT_FIELD: {
        displayName: 'Text field',
        isShrinkable: true,
        minWidth: 100,
        type: TextField,
    },
    TEXT_FORM_FIELD: {
        displayName: 'Text form input',
        isFormField: true,
        isShrinkable: true,
        minWidth: 100,
        type: TextFormInput,
    },
    TIME_PICKER: {
        displayName: 'Time picker',
        isShrinkable: true,
        minWidth: 100,
        type: TimePicker,
    },
    TIME_FORM_PICKER: {
        displayName: 'Time form picker',
        isFormField: true,
        isShrinkable: true,
        minWidth: 100,
        subtype: TimePicker,
        type: TimePickerFormInput,
    },
    TOGGLE_BUTTON: {
        displayName: 'Toggle button',
        type: ToggleButton,
    },
    TOGGLE_BUTTON_GROUP: {
        displayName: 'Toggle button group',
        type: ToggleButtonGroup,
    },
    TOOLTIP: {
        displayName: 'Tooltip',
        type: Tooltip,
    },
    TOP_NAV_ITEM: {
        displayName: 'Top nav item',
        type: TopNavItem,
    },
};
/**
 * A generic enum for defining the alignment.
 */
export var Alignment;
(function (Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
})(Alignment || (Alignment = {}));
/**
 * An enum for defining the visibility of the element. If not defined then the element will be displayed by default
 * but will be put in the overflow menu in case there is no space left for it.
 */
export var Visibility;
(function (Visibility) {
    /**
     * Element will be always put in the overflow menu.
     */
    Visibility[Visibility["HIDDEN"] = 0] = "HIDDEN";
    /**
     * Element will be always displayed, i.e. will not be put in the overflow menu in any case.
     */
    Visibility[Visibility["ALWAYS"] = 1] = "ALWAYS";
})(Visibility || (Visibility = {}));
